import React from 'react';
import ScreenWrapper from '../features/Theme/ScreenWrapper';
import PrivacyPolicy from '../features/LegalDocuments/PrivacyPolicy';

type Props = {
    setActiveRightTab?: Function;
};

export default function PrivacyPolicyScreen({ setActiveRightTab }: Props) {
    return (
        <ScreenWrapper>
            <PrivacyPolicy setActiveRightTab={setActiveRightTab} />
        </ScreenWrapper>
    );
}
